import React, { useEffect, useState } from 'react'
import { Button, Form, Modal, Grid, Dropdown } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import { useForm } from 'react-hook-form'
import Swal from 'sweetalert2'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useSelector } from 'react-redux'
import modalStyles from './asset-modal.module.css'
import styles from '../../../device/device-info-view/device-view.module.css'
import StatusDialog from '../../../../status-dialog'
import IntelMsg from '../../../../ItelMsg/index'
import {
  saveDevice,
  GetSitesUnderCustomer,
} from '../../../../../services/asset'
import { GetAllCustomers } from '../../../../../services/customer'

const initialState = {
  imei: '',
  imsi: null,
  warranty: null,
  siteName: null,
  deviceModel: null,
  customer: '',
  deliveryDate: '',
  deviceLabel: null,
}
const regex = /([+]|00)[0-9]{3,}$/g

const formValidator = {
  imei: yup
    .string()
    .required('Please type IMEI')
    .min(15, 'Please type 15-digit number')
    .max(15, 'IMEI cannot exceed 15 digits'),
  imsi: yup
    .string()
    .nullable()
    .notRequired()
    .transform((value) => (value === '' ? null : value))
    .min(6, 'Too Short'),
  warranty: yup
    .string()
    .nullable()
    .notRequired()
    .transform((value) => (value === '' ? null : value)),
  deliveryDate: yup
    .date()
    .nullable()
    .notRequired()
    .transform((value, originalValue) => (originalValue === '' ? null : value)),
  siteName: yup
    .string()
    .nullable()
    .notRequired()
    .transform((value) => (value === '' ? null : value)),
  deviceModel: yup
    .string()
    .nullable()
    .notRequired()
    .transform((value) => (value === '' ? null : value)),
  customer: yup.string().required('Please select Customer'),
  deviceLabel: yup
    .string()
    .nullable()
    .notRequired()
    .transform((value) => (value === '' ? null : value)),
  sim: yup
    .string()
    .nullable()
    .notRequired()
    .transform((value) => (value === '' ? null : value))
    .matches(regex, 'Number must starts with + or 00 and NOT exceed 11 digits'),
}

const AddAsset = ({ show, setShow }) => {
  const [options, setOptions] = useState([])
  const { userEmail } = useSelector((store) => ({
    userEmail: store.auth.userEmail,
  }))
  const productName = localStorage.getItem('product')
  const { register, handleSubmit, errors, getValues } = useForm({
    resolver: yupResolver(yup.object().shape(formValidator)),
    shouldFocusError: false,
    defaultValues: initialState,
  })
  const [customersList, setCustomersList] = useState([])
  const [sitesList, setSitesList] = useState([])
  // eslint-disable-next-line no-unused-vars
  const [selectState, setSelectState] = useState()
  // eslint-disable-next-line no-unused-vars
  const [selectSiteState, setSelectSiteState] = useState()
  const [customer, setCustomer] = useState()
  const [site, setSite] = useState()

  useEffect(() => {
    console.log(errors)
  }, [errors])
  const [disableSubmit] = useState(false)
  const [showStatusDialog, setShowStatusDialog] = useState(false)

  // eslint-disable-next-line no-unused-vars
  const [formData, setFormData] = useState(initialState)

  const formChangeHandler = (e) => {
    const { name: inputName } = e.target
    const { value } = e.target
    setFormData((prevState) => ({ ...prevState, [inputName]: value }))
  }

  useEffect(() => {
    if (userEmail) {
      GetAllCustomers(userEmail, productName).then((data) => {
        console.log('Customer List', data)
        setCustomersList(data || [])
      })
    }
  }, [userEmail])

  useEffect(() => {
    GetSitesUnderCustomer(customer, 'site', productName).then((data) => {
      console.log('sitesss:', data)
      setSitesList(data || [])
    })
  }, [customer])

  const handleCustomerSelect = (e) => {
    const [id, name] = e.target.value.split(',')
    setCustomer(id)
    setSelectState(e.target.value)
    console.log('m', id, name)
  }
  // eslint-disable-next-line no-unused-vars
  const handleSiteSelect = (e, { value }) => {
    console.log('vallll: ', value)
    const [id, name] = value.split(',')
    setSite(id)
    setSelectSiteState(name)
    console.log(id, name)
  }

  function submitHandler(data) {
    console.log('form data recieved: ', data)
    console.log(site, selectSiteState)
    console.log('customer sentttt: ', customer)
    const payload = {
      imei: data.imei,
      imsi: data.imsi || null,
      warranty: data.warranty || null,
      deliveryDate: data.deliveryDate || null,
      siteName: data.siteName || null,
      deviceModel: data.deviceModel || null,
      deviceLabel: data.deviceLabel || null,
      sim: data.sim || null,
    }
    console.log('payload  ', payload)
    saveDevice(
      userEmail,
      productName,
      customer,
      payload.deviceModel,
      payload.imei,
      payload.imsi,
      payload.deliveryDate,
      payload.deviceLabel,
      payload.sim,
      payload.warranty,
      payload.siteName,
      // getValues().deviceModel,
      // getValues().imei,
      // getValues().imsi,
      selectSiteState,
      // getValues().deviceLabel,
      // site,
      // getValues().sim,
      // getValues().warranty,
      // getValues().deliveryDate,
    ).then((_data) => {
      if (_data.status === 200) {
        setShow(false)
        Swal.fire({
          title: 'Device Added Successfully!',
          confirmButtonColor: 'Green',
          icon: 'success',
        })
      } else {
        Swal.fire({
          title: _data.msg || 'Error Adding Device!',
          confirmButtonColor: 'Red',
          icon: 'error',
        })
      }
    })
  }

  useEffect(() => {
    const newOptions = sitesList.map((item) => ({
      key: item.id,
      text: item.label || item.name,
      value: `${item.id},${item.name}`,
    }))
    setOptions(newOptions)
  }, [sitesList])

  const handleClose = () => setShow(false)

  return (
    <>
      <div>
        <Modal
          onClose={() => setShow(false)}
          onOpen={() => setShow(true)}
          open={show}
          centered
          style={{ position: 'relative', height: 'auto' }}
        >
          <Modal.Header className={modalStyles.header} closeButton>
            <IntelMsg id="addDeviceHeaderModal" />
          </Modal.Header>
          <Modal.Content scrolling>
            <Form
              id="deviceAddForm"
              onSubmit={handleSubmit(submitHandler)}
              widths="equal"
            >
              <Form.Field>
                <Grid columns={2}>
                  <Grid.Row>
                    <Grid.Column>
                      <span style={{ color: 'black' }}>Customer:</span>
                      <select
                        name="customer"
                        ref={register}
                        style={{
                          width: 410,
                          height: 40,
                          backgroundColor: errors.customer ? '#ffe2e7' : null,
                        }}
                        onChange={handleCustomerSelect}
                      >
                        <option disabled selected>
                          Choose Customer
                        </option>
                        {customersList.map((item) => (
                          <option
                            key={item.title}
                            value={`${item.tbCustomerId},${item.title}`}
                          >
                            {item.title}
                          </option>
                        ))}
                      </select>
                      <small style={{ color: 'red' }}>**</small>
                      <br />
                      <p style={{ color: 'red' }}>
                        {' '}
                        {errors.customer && errors.customer.message}{' '}
                      </p>
                    </Grid.Column>
                    <Grid.Column>
                      <span style={{ color: 'black' }}>Device Model:</span>
                      <input
                        name="deviceModel"
                        placeholder="..."
                        ref={register}
                        onChange={formChangeHandler}
                        className={
                          errors.deviceModel ? styles.errorField : null
                        }
                        style={{
                          width: 410,
                          height: 40,
                          backgroundColor: errors.deviceModel
                            ? '#ffe2e7'
                            : null,
                        }}
                      />
                      <br />
                      <p style={{ color: 'red' }}>
                        {' '}
                        {errors.deviceModel && errors.deviceModel.message}{' '}
                      </p>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Form.Field>
              <Form.Field>
                <Grid columns={2}>
                  <Grid.Row>
                    <Grid.Column>
                      <span style={{ color: 'black' }}>(Device ID) IMEI:</span>
                      <input
                        className={errors.imei ? styles.errorField : null}
                        type="number"
                        name="imei"
                        ref={register}
                        onChange={formChangeHandler}
                      />
                      <small style={{ color: 'red' }}>**</small>
                      <br />
                      <p style={{ color: 'red' }}>
                        {' '}
                        {errors.imei ? errors.imei.message : null}{' '}
                      </p>
                    </Grid.Column>
                    <Grid.Column>
                      <span style={{ color: 'black' }}>IMSI:</span>
                      <input
                        type="number"
                        className={
                          errors.imsi && getValues('imsi')
                            ? styles.errorField
                            : null
                        }
                        name="imsi"
                        ref={register}
                        onChange={formChangeHandler}
                        placeholder="..."
                      />
                      <br />
                      <p style={{ color: 'red' }}>
                        {' '}
                        {errors.imsi && getValues('imsi')
                          ? errors.imsi.message
                          : null}{' '}
                      </p>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Form.Field>
              <Form.Field>
                <Grid columns={2}>
                  <Grid.Row>
                    <Grid.Column>
                      <span style={{ color: 'black' }}>Site Name:</span>
                      <Dropdown
                        name="siteName"
                        ref={register}
                        onChange={handleSiteSelect}
                        options={options}
                        selection
                        placeholder="select site"
                        search
                        style={{
                          width: 410,
                          height: 40,
                          backgroundColor: errors.siteName ? '#ffe2e7' : null,
                        }}
                      />
                      <br />
                      <p style={{ color: 'red' }}>
                        {' '}
                        {errors.siteName ? errors.siteName.message : null}{' '}
                      </p>
                    </Grid.Column>
                    <Grid.Column>
                      <span style={{ color: 'black' }}>SIM Number:</span>
                      <input
                        className={
                          errors.sim && getValues('sim')
                            ? styles.errorField
                            : null
                        }
                        name="sim"
                        placeholder="..."
                        ref={register}
                        onChange={formChangeHandler}
                      />
                      <br />
                      <p style={{ color: 'red' }}>
                        {' '}
                        {errors.sim && getValues('sim')
                          ? errors.sim.message
                          : null}{' '}
                      </p>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <span style={{ color: 'black' }}>Device Label:</span>
                      <input
                        className={
                          errors.deviceLabel ? styles.errorField : null
                        }
                        name="deviceLabel"
                        placeholder="..."
                        ref={register}
                        onChange={formChangeHandler}
                      />
                      <br />
                      <p style={{ color: 'red' }}>
                        {' '}
                        {errors.deviceLabel
                          ? errors.deviceLabel.message
                          : null}{' '}
                      </p>
                    </Grid.Column>
                    <Grid.Column>
                      <span style={{ color: 'black' }}>Warranty:</span>
                      <input
                        type="number"
                        className={errors.warranty ? styles.errorField : null}
                        name="warranty"
                        ref={register}
                        onChange={formChangeHandler}
                        placeholder="..."
                      />
                      <br />
                      <p style={{ color: 'red' }}>
                        {' '}
                        {errors.warranty ? errors.warranty.message : null}{' '}
                      </p>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <span style={{ color: 'black' }}>Delivery Date:</span>
                      <input
                        type="date"
                        className={
                          errors.deliveryDate && getValues('deliveryDate')
                            ? styles.errorField
                            : null
                        }
                        name="deliveryDate"
                        ref={register}
                        onChange={formChangeHandler}
                        placeholder="..."
                      />
                      <br />
                      <p style={{ color: 'red' }}>
                        {' '}
                        {errors.deliveryDate && getValues('deliveryDate')
                          ? errors.deliveryDate.message
                          : null}{' '}
                      </p>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Form.Field>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button
              id="submit"
              type="submit"
              disabled={disableSubmit}
              onClick={handleSubmit(submitHandler)}
              className={modalStyles.positiveStatus}
            >
              <IntelMsg id="loginSubmitButton" />
            </Button>
            <Button
              className={modalStyles.negativeStatus}
              onClick={() => {
                handleClose()
              }}
            >
              <IntelMsg id="closeBtn" />
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
      <StatusDialog
        showDialog={showStatusDialog}
        setShowDialog={setShowStatusDialog}
        dialogHeader={<IntelMsg id="Asset" />}
        // dialogContent={dialogContent}
      />
    </>
  )
}
AddAsset.propTypes = {
  setShow: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
}
export default AddAsset
